//dependencias
import React, { Component } from 'react';

//componentes
import ReporteNotasAction from './reporteNotas'

class Index extends Component {

    render(){
        return(
            <div>
                <ReporteNotasAction />
            </div>
        );
    }

}
export default Index;